var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monthly-chart"},[_c('CCard',[_c('CCardBody',[_c('h5',{staticClass:"text-primary"},[_vm._v("Monthly Applications Overview")]),_c('div',[_c('BasicBar',{attrs:{"data":_vm.getMonthlyChartData,"height":300}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }